import {PageTitle} from 'componentsStyled/Typography/Titles';
import styled from 'styled-components';

export const StyledPageTitle = styled(PageTitle)`
  margin-bottom: 7rem;
`;
